<div class="groupBasket-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="groupOverview-content">
      <div class="groupOverview-info-item title-margin">
        <h2 class="title info-label" [innerHTML]="groupOverViewTitle"></h2>
      </div>
      <!--Invite button-->
      <div class="invite-container">
        <div class="group-invite-content" (click)="NavigateToShareLink()">
          <div class="invite-header_icon">
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="hypersoft-user-plus.svg"></div>
            </div>
          </div>
          <span class="text" langkey="phGroupOrder_Share_Title"> </span>
        </div>
      </div>
      <!-- Members Overview-->
      <div class="group-members-container">
        <ng-container *ngIf="groupMembers$| async; let  members">
          <ng-container
            *ngFor="let member of members | slice:0:(show_more?members.length : 6 ); let i=index;trackBy: trackMemberOverviewBy">
            <div class="group-member-content" (click)="ViewGroupMemberOrder(member.userId)">
              <div class="content_wrapper">
                <div class="list-header_icon">
                  <div class="icon-container">
                    <div class="inline-icon" inlineSVG="hypersoft-user-single.svg"></div>
                  </div>
                </div>
                <div class="group-member-info">
                  <div class="member-info_name">
                    <span class="text">{{member.name}}</span>
                  </div>
                </div>
              </div>
              <div class="group-member-content_info">
                <div class="group-member-content_order">
                  <!--items in basket-->
                  <div class="basket-items">
                    <span class="text content-container--subfont"
                      langkey="phGroupOrder_GroupOverview_UserList_Basket"></span>
                    <div class="items_overview">
                      <ng-container *ngIf="member.itemsCount > 0; then basketTemplate else emptyBasketTemplate">
                      </ng-container>
                      <ng-template #basketTemplate>
                        <span class="text content-container--subfont">{{setItemAmount(member.itemsAmount)}}</span>
                        <span
                          class="text items-count content-container--subfont">({{setItemsCount(member.itemsCount)}})</span>
                      </ng-template>
                      <ng-template #emptyBasketTemplate>
                        <span class="text content-container--subfont">-</span>
                      </ng-template>
                    </div>
                  </div>
                  <div class="content-divider"></div>
                  <div class="state state--ready">
                    <span class="text state-label content-container--subfont"
                      langkey="phRemoteOrder_Group_Member_State"></span>
                    <div class="items_overview">
                      <span *ngIf="member.stateReady" class="text content-container--subfont"
                        langkey="phRemoteOrder_Group_Member_State_Ready"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="groupMembers$| async; let  members">
          <ng-container *ngIf="Displaytoggle(members.length)">
            <div class="show_more" (click)="toggleShowMore()" [ngClass]="{'active': show_more === true}">
              <div class="icon-container">
                <div class="inline-icon" inlineSVG="hypersoft-pfeil-unten-voll.svg"></div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <!-- Information about the group basket -->
    <div class="groupBasket_list_info" [class.customized-spacing]="!userIsGroupCreator">
      <ng-container *ngIf="item_count$ | async; let itemCount; then infoTemplate  else emptyTemplate"></ng-container>
      <ng-template #infoTemplate>
        <p>
          <span langkey="phGroupOrder_GroupOverview_Basket_Title"></span>:
        </p>
        <div class="group-basket_info">
          <p>
            <ng-container *ngIf="item_count$ | async; let itemCount">
              <span>{{setIGroupOrderCount(itemCount)}}</span>
              <span class="middle-text" langkey="phGroupOrder_GroupOverview_Basket_Info"></span>
            </ng-container>
            <ng-container *ngIf="open_price$ | async; let openPrice">
              <span>{{setItemAmount(openPrice)}}</span>
            </ng-container>
          </p>
        </div>
        <ng-container *ngIf="userIsGroupCreator">
          <div class="botton-wrapper">
            <div class="ya-webshop-button-container">
              <button mat-flat-button (click)="navigateToPayment()">
                <span langkey="phGroupOrder_GroupOverview_Basket_PlaceGroupOrder_Btn"></span>
              </button>
            </div>
          </div>
        </ng-container>
      </ng-template>
      <ng-template #emptyTemplate>
        <p class="title" langkey="phGroupOrder_GroupOverview_Basket_NoOrder_Title"></p>
        <ng-container *ngIf="userIsGroupCreator">
          <div class="botton-wrapper">
            <div class="ya-webshop-button-container">
              <button mat-flat-button disabled>
                <span langkey="phGroupOrder_GroupOverview_Basket_PlaceGroupOrder_Btn"></span>
              </button>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </div>
    <!-- Group basket -->
    <ng-container *ngIf="groupbasketItems$ | async; let  groupbasketItems">
      <div class="basket">
        <div class="col">
          <div class="ya-item-list-contaner">
            <ng-container *ngFor="let groupMember of groupbasketItems">
              <div class="basketItems_header">
                <div class="user-container">
                  <div class="icon-container">
                    <div class="inline-icon" inlineSVG="hypersoft-user-single.svg"></div>
                  </div>
                  <span>{{groupMember.name}}</span>
                </div>
                <ng-container *ngIf="currentlyUserIsOwner(groupMember.userId)">
                  <div class="user-container selection-state">
                    <span langkey="phRemoteOrder_Group_Set_State_Ready"></span>
                    <mat-checkbox class="checkItems custom-ripple" [checked]="groupMember.stateReady"
                      (change)="changeStateReady(groupMember.userId,$event)">
                    </mat-checkbox>
                  </div>
                </ng-container>
              </div>
              <ng-container *ngFor="let basketItem of groupMember.items; let i = index">
                <ya-basketItemCard [basketItem]="basketItem"
                  [canModifyBasket]="currentlyUserIsOwner(groupMember.userId)"></ya-basketItemCard>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>